import React from 'react';
import { XIcon, CheckIcon, CrownIcon, SirenIcon, MegaphoneIcon, UsersIcon } from 'lucide-react';
const withoutItems = ['Planillas básicas y genéricas', 'Sin protocolos de urgencias clínicas', 'Sin estrategias para conseguir más clientes', 'Sin sistema de gestión de tu equipo'];
const withItems = ['Kit ampliado con planillas profesionales especializadas', 'Protocolo de urgencias listo para actuar sin dudar', 'Kit de marketing para llenar tu agenda de turnos', 'Gestión de personal y equipo organizada desde el día uno'];
const tools = [{
  icon: SirenIcon,
  label: 'PRO #1',
  title: 'Protocolo de Atención de Urgencias',
  description: 'Flujogramas clínicos paso a paso para las emergencias más frecuentes. Actuá sin dudar cuando más importa.'
}, {
  icon: MegaphoneIcon,
  label: 'PRO #2',
  title: 'Kit de Marketing para Veterinarios',
  description: 'Estrategias concretas para conseguir y retener clientes en Argentina. Llenás la agenda sin bajar precios.'
}, {
  icon: UsersIcon,
  label: 'PRO #3',
  title: 'Gestión de Personal y Equipo',
  description: 'Planillas completas para contratar, organizar y liderar tu equipo veterinario con estructura profesional.'
}];
export function EliteProValue() {
  return <section className="bg-mint py-12 px-6" data-id="element-50">
      <div className="max-w-md mx-auto space-y-8" data-id="element-51">
        <div className="text-center space-y-3" data-id="element-52">
          <div className="inline-flex items-center gap-2 bg-teal/10 border border-teal/30 text-teal px-4 py-1.5 rounded-full text-sm font-bold" data-id="element-53">
            <CrownIcon className="w-4 h-4" data-id="element-54" />
            EXCLUSIVO KIT ELITE PRO
          </div>
          <h2 className="text-2xl font-bold text-navy leading-tight" data-id="element-55">
            Qué vas a obtener con el{' '}
            <span className="text-teal-bright" data-id="element-56">KIT ELITE PRO</span>
          </h2>
          <p className="text-[15px] text-navy/70 leading-relaxed" data-id="element-57">
            La diferencia entre tener planillas básicas y un sistema profesional
            completo de gestión
          </p>
        </div>

        {/* Comparison cards */}
        <div className="space-y-4" data-id="element-58">
          <div className="bg-white border border-navy/10 rounded-2xl p-6 space-y-4" data-id="element-59">
            <div className="inline-flex items-center gap-2 bg-navy/5 text-navy/70 px-3 py-1 rounded-full text-xs font-semibold" data-id="element-60">
              <XIcon className="w-3.5 h-3.5" data-id="element-61" />
              SI NO TENÉS EL KIT ELITE PRO
            </div>
            <div className="space-y-3" data-id="element-62">
              {withoutItems.map((item, i) => <div key={i} className="flex items-start gap-2" data-id="element-63">
                  <XIcon className="w-4 h-4 text-red-400 flex-shrink-0 mt-0.5" data-id="element-64" />
                  <span className="text-sm text-navy/70" data-id="element-65">{item}</span>
                </div>)}
            </div>
          </div>

          <div className="relative bg-navy border-2 border-teal-bright rounded-2xl p-6 pt-7 space-y-4 shadow-xl" data-id="element-66">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2" data-id="element-67">
              <div className="inline-flex items-center gap-1.5 bg-teal-bright text-navy px-4 py-1 rounded-full text-xs font-bold whitespace-nowrap" data-id="element-68">
                <CrownIcon className="w-3.5 h-3.5" data-id="element-69" />
                RECOMENDADO
              </div>
            </div>
            <div className="inline-flex items-center gap-2 bg-white/10 text-teal-bright px-3 py-1 rounded-full text-xs font-semibold" data-id="element-70">
              <CheckIcon className="w-3.5 h-3.5" data-id="element-71" />
              SI TENÉS EL KIT ELITE PRO
            </div>
            <p className="text-white font-bold" data-id="element-72">
              Tenés un sistema veterinario completo
            </p>
            <div className="space-y-3" data-id="element-73">
              {withItems.map((item, i) => <div key={i} className="flex items-start gap-2" data-id="element-74">
                  <CheckIcon className="w-4 h-4 text-teal-bright flex-shrink-0 mt-0.5" data-id="element-75" />
                  <span className="text-sm text-white/90" data-id="element-76">{item}</span>
                </div>)}
            </div>
          </div>
        </div>

        {/* 3 exclusive tools */}
        <div className="text-center space-y-2 pt-2" data-id="element-77">
          <h3 className="text-xl font-bold text-navy" data-id="element-78">
            3 herramientas exclusivas del Kit Elite PRO
          </h3>
          <p className="text-sm text-navy/60" data-id="element-79">
            Solo disponibles si elegís el Plan PRO
          </p>
        </div>

        <div className="space-y-4" data-id="element-80">
          {tools.map((tool, i) => {
          const Icon = tool.icon;
          return <div key={i} className="bg-white border border-navy/10 rounded-2xl p-6 space-y-3" data-id="element-81">
                <div className="flex items-center gap-3" data-id="element-82">
                  <div className="w-11 h-11 rounded-xl bg-teal/10 flex items-center justify-center" data-id="element-83">
                    <Icon className="w-5 h-5 text-teal" data-id="element-84" />
                  </div>
                  <span className="text-xs font-bold text-teal tracking-wide" data-id="element-85">
                    {tool.label}
                  </span>
                </div>
                <h4 className="font-bold text-navy" data-id="element-86">{tool.title}</h4>
                <p className="text-sm text-navy/70 leading-relaxed" data-id="element-87">
                  {tool.description}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}